import React from "react";

export interface FavouritesManagerContext {
	onFaveClick: (
		eventDog: DogsTrust.EventDogData,
		option: DogsTrust.FavouriteOption,
		favouriteDog: DogsTrust.DogData,
	) => void;
}
export const FavouritesManagerContext =
	React.createContext<FavouritesManagerContext>({
		onFaveClick: () => {},
	});
